/** @file Load-time region quad: slot-bone-space corners (BL, TL, TR, BR) of the trimmed rect and page UVs. */
import { affine } from '@pose2d/math/affine';
import type { Affine } from '@pose2d/math/types';
import type { AtlasRegion } from '@pose2d/format/types';
import { regionUv } from '../../load/regionUv';

/** Trimmed-rect pixel corners mapped through toLocal (8 floats) and, normalized by origW/origH, through regionUv. */
export function regionCorners(toLocal: Affine, region: AtlasRegion, pageW: number, pageH: number): { local: Float64Array; uvs: Float32Array } {
  const left = region.offL;
  const top = region.origH - region.h - region.offB;
  const right = left + region.w;
  const bottom = top + region.h;
  const pixels = [left, bottom, left, top, right, top, right, bottom];
  const local = new Float64Array(8);
  const point: [number, number] = [0, 0];
  for (let i = 0; i < 8; i += 2) {
    affine.apply(toLocal, pixels[i] ?? 0, pixels[i + 1] ?? 0, point);
    local[i] = point[0];
    local[i + 1] = point[1];
  }
  const uvs = new Float32Array(8);
  regionUv(uvs, pixels.map((v, i) => (i % 2 === 0 ? v / region.origW : v / region.origH)), region, pageW, pageH);
  return { local, uvs };
}
